import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TaskListFolderImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TaskListFolderImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const TaskListFolderImage = (t0)=>{
    const $ = c(37);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M4 8C4 3.58172 7.58172 0 12 0H35.3563C37.7036 0 39.6063 1.90279 39.6063 4.25C39.6063 6.59721 41.5091 8.5 43.8563 8.5H52C56.4183 8.5 60 12.0817 60 16.5L60 64H4V8Z",
            fill: "white"
        });
        $[2] = t1;
    } else t1 = $[2];
    const t2 = `url(#paint0_${props.id})`;
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M38.6064 4.25C38.6064 2.45511 37.1513 1.00006 35.3564 1H12C8.13401 1 5 4.13401 5 8V63H59V16.5C59 12.634 55.866 9.5 52 9.5H43.8564C40.957 9.5 38.6064 7.14949 38.6064 4.25ZM39.6123 4.46875C39.7225 6.64186 41.4646 8.384 43.6377 8.49414L43.8563 8.5H52C56.4183 8.5 60 12.0817 60 16.5L60 64H4V8C4 3.58172 7.58172 0 12 0H35.3563L35.5752 0.00585938C37.7482 0.116095 39.4904 1.8582 39.6006 4.03125L39.6123 4.46875Z",
            fill: t2
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = `url(#paint1_${props.id})`;
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M11 27.5C11 26.1193 12.1193 25 13.5 25H50.5C51.8807 25 53 26.1193 53 27.5C53 28.8807 51.8807 30 50.5 30H13.5C12.1193 30 11 28.8807 11 27.5Z",
            fill: t4
        });
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = `url(#paint2_${props.id})`;
    let t7;
    if ($[7] !== t6) {
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M11 9C11 6.79086 12.7909 5 15 5H29C31.2091 5 33 6.79086 33 9V16C33 18.2091 31.2091 20 29 20H15C12.7909 20 11 18.2091 11 16V9Z",
            fill: t6
        });
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t3 || $[10] !== t5 || $[11] !== t7) {
        t8 = /*#__PURE__*/ jsx("g", {
            children: /*#__PURE__*/ jsxs("g", {
                children: [
                    t1,
                    t3,
                    t5,
                    t7
                ]
            })
        });
        $[9] = t3;
        $[10] = t5;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    const t9 = `paint0_${props.id}`;
    let t10;
    let t11;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsx("stop", {
            stopColor: "currentColor"
        });
        t11 = /*#__PURE__*/ jsx("stop", {
            offset: "0.780666",
            stopColor: "white"
        });
        $[13] = t10;
        $[14] = t11;
    } else {
        t10 = $[13];
        t11 = $[14];
    }
    let t12;
    if ($[15] !== t9) {
        t12 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t9,
            x1: "40",
            y1: "-14.5",
            x2: "18.5",
            y2: "67.5",
            gradientUnits: "userSpaceOnUse",
            children: [
                t10,
                t11
            ]
        });
        $[15] = t9;
        $[16] = t12;
    } else t12 = $[16];
    const t13 = `paint1_${props.id}`;
    let t14;
    let t15;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t15 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[17] = t14;
        $[18] = t15;
    } else {
        t14 = $[17];
        t15 = $[18];
    }
    let t16;
    if ($[19] !== t13) {
        t16 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t13,
            x1: "32",
            y1: "25",
            x2: "32",
            y2: "30",
            gradientUnits: "userSpaceOnUse",
            children: [
                t14,
                t15
            ]
        });
        $[19] = t13;
        $[20] = t16;
    } else t16 = $[20];
    const t17 = `paint2_${props.id}`;
    let t18;
    let t19;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t19 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[21] = t18;
        $[22] = t19;
    } else {
        t18 = $[21];
        t19 = $[22];
    }
    let t20;
    if ($[23] !== t17) {
        t20 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t17,
            x1: "22",
            y1: "5",
            x2: "22",
            y2: "20",
            gradientUnits: "userSpaceOnUse",
            children: [
                t18,
                t19
            ]
        });
        $[23] = t17;
        $[24] = t20;
    } else t20 = $[24];
    const t21 = `clip0_${props.id}`;
    let t22;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsx("rect", {
            width: "64",
            height: "60",
            fill: "white"
        });
        $[25] = t22;
    } else t22 = $[25];
    let t23;
    if ($[26] !== t21) {
        t23 = /*#__PURE__*/ jsx("clipPath", {
            id: t21,
            children: t22
        });
        $[26] = t21;
        $[27] = t23;
    } else t23 = $[27];
    let t24;
    if ($[28] !== t12 || $[29] !== t16 || $[30] !== t20 || $[31] !== t23) {
        t24 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t12,
                t16,
                t20,
                t23
            ]
        });
        $[28] = t12;
        $[29] = t16;
        $[30] = t20;
        $[31] = t23;
        $[32] = t24;
    } else t24 = $[32];
    let t25;
    if ($[33] !== props || $[34] !== t24 || $[35] !== t8) {
        t25 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "64",
            height: "60",
            viewBox: "0 0 64 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t8,
                t24
            ]
        }));
        $[33] = props;
        $[34] = t24;
        $[35] = t8;
        $[36] = t25;
    } else t25 = $[36];
    return t25;
};
export { TaskListFolderImage };
